<template>
  <!-- 巡检维修-事件管理-选中列表-发布任务 -->
  <a-modal title="发布任务" :visible="showTubeView" :width="800" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisiblet"
      @ok="mapVisiblet = false"
      @cancel="mapVisiblet = false"
    >
      <lonlat-map @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="16">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="关联事件" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <span>{{ addOrUpdateForm.eventNo }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="任务编号" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
            <span>(系统自动生成)</span>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="任务名称" prop="taskName">
            <a-input placeholder="请输入任务名称" v-model="addOrUpdateForm.taskName" />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="任务类型" prop="taskType">
            <a-select placeholder="请选择任务类型" v-model="addOrUpdateForm.taskType">
              <a-select-option v-for="item in TaskList" :key="item.dictValue">{{ item.dictValue }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :md="12" :sm="24">
          <a-form-model-item label="负责人" prop="principal">
            <a-select
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              v-model="addOrUpdateForm.principal"
              @change="handleChange"
            >
              <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="协办人">
            <a-button @click="addSponsor" style="margin-right: 20px">添加</a-button>
            <a-tag v-for="item in assistPersonsList" :key="item.key" closable @close="delSponsor(item.key)">{{
              item.title
            }}</a-tag>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="片区">
            <a-tree-select
              :tree-data="zoneTreeData"
              v-model="addOrUpdateForm.zoneId"
              :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择片区"
              allow-clear
              tree-default-expand-all
            ></a-tree-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <!-- <a-form-model-item label="位置" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-button type="primary" @click="mapVisiblet = true">位置</a-button>
            <a-input placeholder="请输入" v-model="addOrUpdateForm.place" />
          </a-form-model-item> -->
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="计划开始时间" prop="predictStime">
            <a-date-picker 
              v-model="addOrUpdateForm.predictStime"
              placeholder="计划开始时间"
              :disabled-date="disabledDate"
              :disabled-time="disabledDateTime"
              @change="beginOnChange" style="width: 100%;"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="预计处理时长" prop="planTime">
            <a-input placeholder="请输入单位人天" v-model="addOrUpdateForm.planTime" />
          </a-form-model-item>
          <!-- <a-form-model-item label="计划结束时间" prop="predictEtime">
            <a-date-picker
              v-model="addOrUpdateForm.predictEtime"
              show-time
              placeholder="计划结束时间"
              @change="beginOnChangets"
            />
          </a-form-model-item> -->
        </a-col>
        <!-- <a-col :md="24" :sm="24">
          <a-form-model-item label="地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="address">
            <a-textarea placeholder="请输入" v-model="addOrUpdateForm.address" :rows="2" />
          </a-form-model-item>
        </a-col> -->
        <a-col :md="24" :sm="24">
          <a-form-model-item label="任务描述" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" prop="description">
            <a-textarea placeholder="多行输入" v-model="addOrUpdateForm.description" :rows="4" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <addModal ref="addModal" @addPepople="addPepople"></addModal>
  </a-modal>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from './lonlatMap.vue'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
  },
  props: {},
  data() {
    return {
      dayjs,
      mapVisiblet: false,
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        place: '',
        eventId: '',
        taskType: '',
        eventNo: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principal: '',
        predictStime: '',
        predictEtime: '',
        endTime: '',
        taskName: '',
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      TaskList: [],
      records: {},
      assistPersonsList: [],
      userlist: [],
    }
  },
  computed: {
    rules() {
      return {
        taskType: [{ required: true, message: '请选择任务类型', trigger: 'change' }],
        zoneId: [{ required: true, message: '请选择片区', trigger: 'change' }],
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        assistPersons: [{ required: true, message: '请选择协办人', trigger: 'change' }],
        predictStime: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'change' }],
        description: [{ required: true, message: '请输入任务描述', trigger: 'change' }],
        planTime: [
          { required: true, message: '请输入预计处理时长', trigger: 'change' },
          // /^(?:[1-9]\d?|[1234]\d{2}|500)$/
          { pattern: /^([1-9]\d*)(\.\d{1,6})?$|^0\.\d{1,6}?$/, message: '请输入大于零的人天数', trigger: 'change' },
        ],
      }
    },
  },
  created() {
    this.getZoneData()
    this.getTaskList()
    this.getUserList()
  },
  methods: {
    disabledDate(current) {
      return current && current < dayjs().startOf('day')
    },
    disabledDateTime() {},
    beginOnChange(value, dateString) {
      this.addOrUpdateForm.predictStime = dateString + ' 00:00:00'
    },
    beginOnChangets(value, dateString) {
      this.addOrUpdateForm.predictEtime = dateString
    },
    handleMapOk(data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.place = data.point
      console.log(this.addOrUpdateForm.address)
    },
    moment,
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    showLineLayer(record) {
      this.geoJson = record.geoJson
      this.mapVisiblet = true
    },
    delSponsor(key) {
      const i = this.assistPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.assistPersonsList.splice(i, 1)
      const j = this.addOrUpdateForm.assistPersons.indexOf(key)
      this.addOrUpdateForm.assistPersons.splice(j, 1)
    },
    addPepople(list) {
      this.assistPersonsList = list
      this.addOrUpdateForm.assistPersons = []
      list.map((item) => {
        this.addOrUpdateForm.assistPersons.push(item.key)
      })
    },
    addSponsor() {
      this.$refs.addModal.edit(this.addOrUpdateForm.assistPersons)
    },
    getTaskList() {
      const params = {
        dictCode: 'TASK_TYPE',
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.TaskList = data
      })
    },
    handleOk(e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/tenant_events/publish/task', {
              id: this.currentId,
              sysType: '巡检',
              ...this.addOrUpdateForm,
            })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    getZoneData() {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    onChange(value, dateString) {
      this.addOrUpdateForm.startTime = dateString
    },
    onChange(value, dateString) {
      this.addOrUpdateForm.endTime = dateString
    },
    edit(records) {
      this.showTubeView = true
      this.addOrUpdateForm = {
        eventId: '',
        taskType: '',
        eventNo: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principal: '',
        predictStime: '',
        predictEtime: '',
        endTime: '',
        planTime: '',
        taskName: '',
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        this.addOrUpdateForm.eventId = records.id
        this.addOrUpdateForm.eventNo = records.eventNo
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      console.log(this.addOrUpdateForm)
      this.assistPersonsList = []
      this.$emit('handleOk')
    },
  },
}
</script>

<style lang="less" scoped></style>
